import { render, staticRenderFns } from "./AccountHandlers.vue?vue&type=template&id=59fb2f99&"
import script from "./AccountHandlers.vue?vue&type=script&lang=js&"
export * from "./AccountHandlers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports